import { lazy } from 'react';
const CustomPlanificationsDashboard = lazy(() => import('./CustomPlanificationsDashboard'));
export default CustomPlanificationsDashboard;
